import { useDispatch, useSelector } from 'react-redux';
import { List } from 'immutable';
import { records } from '@saucelabs/sl-module-tunnels';

import utils from './utils';
import actions from './actions';
import selectors from './selectors';

interface CurrentAndAvailableTunnels {
  allTunnels: List<records.TunnelRecord>
  tunnel: string
}

function useCheckIfCurrentTunnelAvailable(): void {
  const {
    allTunnels,
    tunnel,
  }: CurrentAndAvailableTunnels = useSelector(selectors.useCheckIfCurrentTunnelAvailableSelector);
  const dispatch = useDispatch();

  if (tunnel && !utils.isTunnelStillRunning(tunnel, allTunnels)) {
    dispatch(actions.updateTestConfigValue({ tunnel: null }));
  }
}

export default {
  useCheckIfCurrentTunnelAvailable,
};
